/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { createContext } from 'react';

export class MetadataContextType {
    // db-stored metadata fields
    info: string;
    serial: string;
    title: string;
    branch: string;
    git_hash: string;
    last_commit_msg: string;
    // app/schema version fields
    appVersion: string;
    schemaVersion: string;
    supportedSchemaVersion: string;
    localSchemaVersion: string;
    supportedLocalSchemaVersion: string;
    // user/session fields
    username: string;
    user_dir: string;
    prefix: string;
    dbFileName: string;
    localDbFileName: string;
    // deployment type: 'electron' | 'linux-prod' | 'web'
    deploymentType: string;
    // last file operation
    lastFileOp?: {
        filename?: string;
        cloud?: string;
    };
    // refresh trigger
    refresh: () => void;
    constructor() {
        this.info = '';
        this.serial = '';
        this.title = '';
        this.branch = '';
        this.git_hash = '';
        this.last_commit_msg = '';
        this.appVersion = 'unknown';
        this.schemaVersion = 'unknown';
        this.supportedSchemaVersion = 'unknown';
        this.localSchemaVersion = 'unknown';
        this.supportedLocalSchemaVersion = 'unknown';
        this.username = 'unknown';
        this.user_dir = 'unknown';
        this.prefix = 'unknown';
        this.dbFileName = '';
        this.localDbFileName = '';
        this.deploymentType = 'web';
        this.lastFileOp = { filename: '', cloud: 'false' };
        this.refresh = () => {};
    }
}

export const MetadataContext = createContext<MetadataContextType>(new MetadataContextType());
